import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { telHref, useContent } from "@/content/ContentProvider";

export default function ConsultCTA() {
  const phone = useContent("site.settings").phone;

  return (
    <section className="relative overflow-hidden bg-primary-500 py-20 md:py-24">
      <div className="pointer-events-none absolute inset-0 grain opacity-50" />
      <div className="relative mx-auto max-w-content px-5 md:px-8">
        <Reveal className="text-center">
          <span className="font-label text-xs tracking-[0.25em] text-foreground-950/60">
            CONSULTATION
          </span>
          <h2 className="mx-auto mt-3 max-w-3xl font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            지금의 실력을 진단하면,
            <br />
            다음 성적이 보입니다
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-foreground-950/70">
            상담 신청을 남겨주시면 담당 선생님이 학습 진단과 함께 가장 적합한
            반을 안내해 드립니다. 상담은 무료입니다.
          </p>

          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/consult"
              className="group inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-7 py-4 text-sm font-bold text-white transition-colors hover:bg-foreground-800 cursor-pointer"
            >
              상담신청 하기
              <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <a
              href={telHref(phone)}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-foreground-950/25 px-7 py-4 text-sm font-bold text-foreground-950 transition-colors hover:bg-foreground-950/5 cursor-pointer"
            >
              <i className="ri-phone-line" />
              {phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}